import React from 'react';

import LocationAndPickup from 'dpl/components/BreederProfile/mobile/components/shared/LocationAndPickup';

export default function BreederProfileDeliverySectionContainer() {
  return (
    <div className="BreederProfileDeliverySectionContainer container-xxl mv8 mv20-md">
      <LocationAndPickup />
    </div>
  );
}
